import type { FC } from 'react';

import PasswordGenerator from '../../../../components/fields/password_generator/password_generator';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'autoFocus',
  'displayCopyIcon',
  'displayGeneratorInField',
] as const;

const Field = formField(PasswordGenerator, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type PasswordGeneratorFieldWrapperProps = FieldWrapperProps<
  typeof Field
>;

const PasswordGeneratorFieldWrapper: FC<PasswordGeneratorFieldWrapperProps> = (
  props,
) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default PasswordGeneratorFieldWrapper;
